/*export to Register*/
/*export to assurer*/
export const CUSTOMER_TYPE_PERSONAL = 1
export const CUSTOMER_TYPE_CORPORATION = 2
export const WEB = 1
export const FACEBOOK = 2
export const LINE = 3
export const TEL = 4

export const MALE = 1
export const FEMALE = 2
export const OTHER = 3

/*export to customer*/
export const customers = [
  {
    id: "depa-30-10-2019",
    customerName_th: "Depa",
    customerName_en: "Depa",
    tripName_th: "Thailand Digital Big bang 2019",
    tripName_en: "Thailand Digital Big bang 2019",
    date_th: "(วันพุธ ที่ 30 ตุลาคม 2562)",
    date_en: "(Wednesday 30 October 2019)",
    image: "hiso-bus-rental-depa.png",
    images: [
      "hiso-bus-rental-depa-1.jpg",
      "hiso-bus-rental-depa-2.jpg",
      "hiso-bus-rental-depa-3.jpg",
      "hiso-bus-rental-depa-4.jpg",
      "hiso-bus-rental-depa-5.jpg",
      "hiso-bus-rental-depa-6.jpg",
      "hiso-bus-rental-depa-7.jpg",
      "hiso-bus-rental-depa-8.jpg"
    ]
  },
  {
    id: "mrta-10-11-2019",
    customerName_th: "การรถไฟฟ้าขนส่งมวลชนแห่งประเทศไทย",
    customerName_en: "Mass Rapid Transit Authority of Thailand",
    tripName_th: "Outing Trip 2019",
    tripName_en: "Outing Trip 2019",
    date_th: "(วันอาทิตย์ ที่ 10 พฤศจิกายน 2562)",
    date_en: "(Sunday 10 November 2019)",
    image: "hiso-bus-rental-mrta.jpg",
    images: ["hiso-bus-rental-mrta-1.jpg", "hiso-bus-rental-mrta-2.jpg"]
  },
  {
    id: "scg-10-11-2019",
    customerName_th: "SCG",
    customerName_en: "SCG",
    tripName_th: "SCG  Outing Trip 2019",
    tripName_en: "SCG  Outing Trip 2019",
    date_th: "(วันอาทิตย์ ที่ 10 พฤศจิกายน 2562)",
    date_en: "(Sunday 10 November 2019)",
    image: "hiso-bus-rental-scg.jpg",
    images: [
      "hiso-bus-rental-scg-1.jpg",
      "hiso-bus-rental-scg-2.jpg",
      "hiso-bus-rental-scg-3.jpg",
      "hiso-bus-rental-scg-4.jpg"
    ]
  },
  {
    id: "yothinburana-10-11-2019",
    customerName_th: "โรงเรียนโยธินบูรณะ",
    customerName_en: "Yothinburana School",
    tripName_th: "ไปเข้าค่ายกันจ้า",
    tripName_en: "Let's go to the camp",
    date_th: "(วันอาทิตย์ ที่ 10 พฤศจิกายน 2562)",
    date_en: "(Sunday 10 November 2019)",
    image: "hiso-bus-rental-yothinburana.jpg",
    images: [
      "hiso-bus-rental-yothinburana-1.jpg",
      "hiso-bus-rental-yothinburana-2.jpg",
      "hiso-bus-rental-yothinburana-3.jpg",
      "hiso-bus-rental-yothinburana-4.jpg",
      "hiso-bus-rental-yothinburana-5.jpg",
      "hiso-bus-rental-yothinburana-6.jpg",
      "hiso-bus-rental-yothinburana-7.jpg"
    ]
  },
  {
    id: "consular-10-10-2019",
    customerName_th: "กรมการกงสุล",
    customerName_en: "Consular",
    tripName_th: "ไป Outing พัทกัน",
    tripName_en: "Let's go Outing Pattaya",
    date_th: "(วันวันพฤหัสบดี ที่ 10 ตุลาคม 2562)",
    date_en: "(Thursday 10 October 2019)",
    image: "hiso-bus-rental-consular.png",
    images: [
      "hiso-bus-rental-consular-1.jpg",
      "hiso-bus-rental-consular-2.jpg",
      "hiso-bus-rental-consular-3.jpg",
      "hiso-bus-rental-consular-4.jpg",
      "hiso-bus-rental-consular-5.jpg",
      "hiso-bus-rental-consular-6.jpg"
    ]
  },
  {
    id: "teleinfomedia-5-10-2019",
    customerName_th: "Teleinfomedia",
    customerName_en: "Teleinfomedia",
    tripName_th: "ไปชะอำมั้ย",
    tripName_en: "Let's go to Cha Am",
    date_th: "(วันเสาร์ ที่ 5 ตุลาคม 2562)",
    date_en: "(Saturday 5 October 2019)",
    image: "hiso-bus-rental-teleinfomedia.jpg",
    images: [
      "hiso-bus-rental-teleinfomedia-1.jpg",
      "hiso-bus-rental-teleinfomedia-2.jpg",
      "hiso-bus-rental-teleinfomedia-3.jpg",
      "hiso-bus-rental-teleinfomedia-4.jpg"
    ]
  },
  {
    id: "wefitness-15-10-2019",
    customerName_th: "We Fitness",
    customerName_en: "We Fitness",
    tripName_th: "ไป Outing ระยอง ฮิ",
    tripName_en: "Let's go outing Rayong",
    date_th: "(วันอังคาร ที่ 15 ตุลาคม 2562)",
    date_en: "(Tuesday 15 October 2019)",
    image: "hiso-bus-rental-wefitness.jpg",
    images: [
      "hiso-bus-rental-wefitness-1.jpg",
      "hiso-bus-rental-wefitness-2.jpg",
      "hiso-bus-rental-wefitness-3.jpg"
    ]
  },
  {
    id: "choco-crm-10-11-2019",
    customerName_th: "Choco CRM",
    customerName_en: "Choco CRM",
    tripName_th: "Choco CRM  Outing Trip 2019",
    tripName_en: "Choco CRM  Outing Trip 2019",
    date_th: "(วันอาทิตย์ ที่ 10 พฤศจิกายน 2562)",
    date_en: "(Sunday 10 November 2019)",
    image: "hiso-bus-rental-choco-crm.jpg",
    images: [
      "hiso-bus-rental-choco-crm-1.jpg",
      "hiso-bus-rental-choco-crm-2.jpg",
      "hiso-bus-rental-choco-crm-3.jpg",
      "hiso-bus-rental-choco-crm-4.jpg"
    ]
  },
  {
    id: "line-11-11-2019",
    customerName_th: "Line Thailand",
    customerName_en: "Line Thailand",
    tripName_th: "Line Thailand Outing 2019",
    tripName_en: "Line Thailand Outing 2019",
    date_th: "(วันจันทร์ ที่ 11 พฤศจิกายน 2562)",
    date_en: "(Monday11 November 2019)",
    image: "hiso-bus-rental-line.jpg",
    images: [
      "hiso-bus-rental-line-1.jpg",
      "hiso-bus-rental-line-2.jpg",
      "hiso-bus-rental-line-3.jpg"
    ]
  },
  {
    id: "tencent-10-10-2019",
    customerName_th: "Tencent",
    customerName_en: "Tencent",
    tripName_th: "ไป Outing กันที่เขาใหญ่",
    tripName_en: "Let's go Outing in Khao Yai",
    date_th: "(วันวันพฤหัสบดี ที่ 10 ตุลาคม 2562)",
    date_en: "(Thursday 10 October 2019)",
    image: "hiso-bus-rental-tencent.jpg",
    images: [
      "hiso-bus-rental-tencent-1.jpg",
      "hiso-bus-rental-tencent-2.jpg",
      "hiso-bus-rental-tencent-3.jpg",
      "hiso-bus-rental-tencent-4.jpg",
      "hiso-bus-rental-tencent-5.jpg"
    ]
  },
  {
    id: "accor-10-11-2019",
    customerName_th: "ACCOR",
    customerName_en: "ACCOR",
    tripName_th: "NOVOTEL Outing Trip 2019",
    tripName_en: "NOVOTEL Outing Trip 2019",
    date_th: "(วันอาทิตย์ ที่ 10 พฤศจิกายน 2562)",
    date_en: "(Sunday 10 November 2019)",
    image: "hiso-bus-rental-accor.png",
    images: [
      "hiso-bus-rental-accor-1.jpg",
      "hiso-bus-rental-accor-2.jpg",
      "hiso-bus-rental-accor-3.jpg",
      "hiso-bus-rental-accor-4.jpg",
      "hiso-bus-rental-accor-5.jpg",
      "hiso-bus-rental-accor-6.jpg",
      "hiso-bus-rental-accor-7.jpg",
      "hiso-bus-rental-accor-8.jpg"
    ]
  },
  {
    id: "dtac-1-10-2019",
    customerName_th: "Dtac",
    customerName_en: "Dtac",
    tripName_th: "ไปหัวหินกัน",
    tripName_en: "Let's go to Hua Hin",
    date_th: "(วันอังคาร ที่ 1 ตุลาคม 2562)",
    date_en: "(Tuesday 1 October 2019)",
    image: "hiso-bus-rental-dtac.jpg",
    images: [
      "hiso-bus-rental-dtac-1.jpg",
      "hiso-bus-rental-dtac-2.jpg",
      "hiso-bus-rental-dtac-3.jpg"
    ]
  }
]



// WEBPACK FOOTER //
// ./src/constants/customer.ts